import { withStyles } from '@material-ui/core';

import styles from '../SingleReceiptForm/styles';
import PeriodReceiptsForm from './component';

export default withStyles(styles)(PeriodReceiptsForm);
